import { gql } from "@apollo/client";

export const CREATE_USERDOCS = gql`
  mutation createUserDocs($input: createUserDocsInput) {
    createUserDocs(input: $input) {
      userId
    }
  }
`;

export const UPDATE_USERDOCS = gql`
  mutation updateUserDocs($input: updateUserDocsInput) {
    updateUserDocs(input: $input)
  }
`;

export const GET_DOCS = gql`
  query userDocs($userId: String!) {
    userDocs(userId: $userId) {
      Id
      userId
      aadhaarNum
      aadhaarUrl
      panNum
      panUrl
      passportNum
      passportUrl
      passportExpDate
      visaNum
      visaUrl
      visaExpDate
      otherDocuments
    }
  }
`;
